// extracted by mini-css-extract-plugin
module.exports = {"oneColumn":"OneColumns_oneColumn__G_L0p"};